import { Button, TextField} from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Rodape from '../rodape.js';
import {extractUTMTags} from '../utm_tags.js';
import Cookies from 'js-cookie';
import { useAuth } from '../../services/AuthContext.js';
import {saveDesiteEventInDB} from '../tracking.js';
import { notify } from '../../services/notify';
import { Header } from '../header.js';
import '../SignupSite.css';
import './account_common.css';

const utmTags = extractUTMTags();

const Signup = () => {
  const redirect = '/allcourses';
  const { login, createUser } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const Navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nameErr, setNameErr] = useState('');
  const [emailErr, setEmailErr] = useState('');

  const [step, setStep] = useState('signup');

  const [isMobile, setIsMobile] = React.useState(false);
  // Function to check if the device is a mobile
  const checkIfMobile = () => {
      const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileDevice);
  };
  React.useEffect(() => {
      checkIfMobile();
      // Add event listener to check if the device type changes
      window.addEventListener('resize', checkIfMobile);
      // Remove event listener on component unmount
      return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const formInputChange = (formField, value) => {
    if (formField === "name") {
      setName(value);
    }
    if (formField === "email") {
      setEmail(value);
    }
  };

  const validation = () => {
    return new Promise((resolve,reject)=>{
      if (name === '' && email === '' && password === '') {
        setNameErr("Digite o seu nome");
        setEmailErr("Digite o seu email");
        resolve({name: "Nome é obrigatório", email:"email necessário"});
      }
      else if (name === '') {
        setNameErr("Digite o seu nome");
        resolve({name: "Nome é obrigatório", email:""});
      }
      else if (email === '') {
        setEmailErr("Digite o seu email");
        resolve({name: "", email:"email necessário"});
      }
      else{
        resolve({name: "", email:""});
      }
      reject('')
    });
  };

  const handleClick = (e) => {
    setNameErr("");
    setEmailErr("");
    validation()
      .then((res) => {
        if (res.email === '' && res.name === '') {
          setIsSubmitting(true);
          createUser(email, name, utmTags["utm_source"])
            .then((data) => {
              window.dataLayer.push({
                event: 'siteSignUp',
                buttonName: 'signUpButton',
              });
              setPassword(data.initial_password);
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'manual_event_SIGNUP'
              });
              setStep('result');
            })
            .catch((err) => {
              console.log(err);
              alert("Erro ao criar conta: " + err.message);
            })
            .finally(() => {
              setIsSubmitting(false);
            });
        }
      })
      .catch(err => console.log(err));
  };

  const handleLogin = () => {
    setIsSubmitting(true);
    login(email, password)
      .then(() => {
        saveDesiteEventInDB("login", "");
        window.location.href = redirect;
      })
      .catch(err => {
        console.log("Login error:", err.message);
        setIsSubmitting(false);
      });
  }

  return (
    <div className="auth-container-common" id="form">
      {step === 'signup' && (
        <>
          <h2>Crie uma conta no site gratuitamente:</h2>
          <p className="signup-benefits">Em instantes você pode começar a estudar gratuitamente no nosso site. Preencha os dados abaixo:</p>
          <div className='form'>
            <div className="formfield">
              <TextField
                size="small"
                value={name}
                fullWidth
                onChange={(e) => formInputChange("name", e.target.value)}
                label="nome"
                helperText={nameErr}
              />
            </div>
            <div className="formfield">
              <TextField
                size="small"
                value={email}
                fullWidth
                onChange={(e) => formInputChange("email", e.target.value)}
                label="email"
                helperText={emailErr}
              />
            </div>
            <div className='formfield'>
              <button type='submit' className="btn-account" onClick={handleClick} disabled={isSubmitting}>
                {isSubmitting ? "Criando conta..." : "Criar conta"}
              </button>
            </div>
            <p className="politicadeprivacidade">Seus dados estão seguros. <br /><a href="../politicadeprivacidade">Política de privacidade</a></p>
          </div>
          <h3>Já tem conta? <br /><a href="logon">Faça o seu login</a></h3>
        </>
      )}
      {step === 'result' && (
        <>
          <h3 className="end-title">
            🎉 Sua conta gratuita no site <span>Domínio Elétrico</span> foi criada!
          </h3>

          <div className="end-info">
            <p>{name}, veja as informações para fazer login no site:</p>
            <ul className="account-result-list">
            <li>
              <span className="label">Link</span>

              <a
                href="https://dominioeletrico.com.br/logon"
                target="_blank"
                rel="noopener noreferrer"
                className="value link"
              >
                https://dominioeletrico.com.br/logon
              </a>
            </li>

            <li>
              <span className="label">Login</span>

              <code className="value credential">
                {email}
              </code>
            </li>

            <li>
              <span className="label">Senha</span>

              <code className="value credential">
                {password}
              </code>
            </li>
          </ul>
            <p>Estas informações também foram enviadas para o seu email.</p>
            <p><b>Sugestão: </b>Adicione o site aos favoritos e salve login e senha no seu gerenciador de senhas.</p>
          </div>

          <div className='formfield'>
            <button type='submit' className="btn-account" onClick={handleLogin} disabled={isSubmitting}>
              {isSubmitting ? "Entrando na área interna..." : "Acesse a área interna do site"}
            </button>
          </div>
        </>
      )}
      
    </div>
  )
}

const SignupSite = () => {
  const { signup } = useAuth();
  const Navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nameErr, setNameErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [passwordErr, setPasswordErr] = useState('');

  const formInputChange = (formField, value) => {
    if (formField === "name") {
      setName(value);
    }
    if (formField === "email") {
      setEmail(value);
    }
    if (formField === "password") {
      setPassword(value);
    }
  };

  const validation = () => {
    return new Promise((resolve,reject)=>{
      if (name === '' && email === '' && password === '') {
        setNameErr("Digite o seu nome");
        setEmailErr("Digite o seu email");
        setPasswordErr("Digite a senha desejada");
        resolve({name: "Nome é obrigatório", email:"email necessário",password:"senha necessária"});
      }
      else if (name === '') {
        setNameErr("Digite o seu nome");
        resolve({name: "Nome é obrigatório", email:"",password:""});
      }
      else if (email === '') {
        setEmailErr("Digite o seu email");
        resolve({name: "", email:"email necessário",password:""});
      }
      else if (password === '') {
        setPasswordErr("Digite a senha desejada");
        resolve({name: "", email:"",password:"senha necessária"});
      }
      else if (password.length < 8) {
        setPasswordErr("Mínimo de 8 caracteres");
        resolve({name: "", email:"",password:"precisa ter pelo menos 8 caracteres"});
      }
      else{
        resolve({name: "", email:"",password:""});
      }
      reject('')
    });
  };

  const handleClick = (e) => {
    setNameErr("");
    setEmailErr("");
    setPasswordErr("");
    validation()
      .then((res) => {
        if (res.email === '' && res.password === '') {
          signup(email, password, name)
            .then((data) => {
              window.dataLayer.push({
                event: 'siteSignUp',
                buttonName: 'signUpButton',
              });
              const user_id = data.userSub;
              notify("SITE SIGNUP", `${name} (${email}) se cadastrou no site!`);
              Navigate(`/verify?email=${email}`);
            })
            .catch((err) => {
              console.log(err);
              alert("Erro ao criar conta: " + err.message);
            });
        }
      })
      .catch(err => console.log(err));
  };
  

  return (
    <>
    <section id="form" className="section">
    <div className="auth-container-signup">
      <h2>Crie uma conta no site gratuitamente:</h2>
      <p className="signup-benefits">Em instantes você pode começar a estudar gratuitamente no nosso site. Preencha os dados abaixo:</p>
      <div className='form'>
        <div className="formfield">
          <TextField
            value={name}
            fullWidth
            onChange={(e) => formInputChange("name", e.target.value)}
            label="nome"
            helperText={nameErr}
          />
        </div>
        <div className="formfield">
          <TextField
            value={email}
            fullWidth
            onChange={(e) => formInputChange("email", e.target.value)}
            label="email"
            helperText={emailErr}
          />
        </div>
        <div className='formfield'>
          <TextField
            value={password}
            fullWidth
            onChange={(e) => { formInputChange("password", e.target.value) }}
            type="password"
            label="senha"
            helperText={passwordErr}
          />
        </div>
        <p className="avisosobresenha">A senha deve ter no mínimo 8 caracteres.</p>
        <div className='formfield'>
          <button type='submit' className="btn-account" onClick={handleClick}>Criar conta</button>
          <p className="politicadeprivacidade">Seus dados estão seguros. <br /><a href="../politicadeprivacidade">Política de privacidade</a></p>
        </div>
      </div>
      <h3>Já tem conta? <br /><a href="logon">Faça o seu login</a></h3>
    </div>
    </section>
    </>
  )
}

// Diceware word list (simplified for demo)
const dicewareWords = [
  'abacate', 'bicicleta', 'cachorro', 'dinossauro', 'elefante', 'fantasma', 'guitarra', 'helicoptero',
  'iguana', 'jacare', 'kiwi', 'lagarto', 'macaco', 'navio', 'oceano', 'papagaio', 'queijo', 'rinoceronte',
  'sapo', 'tigre', 'urubu', 'violino', 'xadrez', 'zebra', 'arvore', 'bola', 'casa', 'dado', 'estrela',
  'fogao', 'galinha', 'harpa', 'ilha', 'janela', 'lampada', 'morango', 'noz', 'oculos', 'piano',
  'quadro', 'radio', 'sol', 'tartaruga', 'uva', 'vaso', 'wifi', 'xaxim', 'yoga', 'zangao',
  'abelha', 'batata', 'camisa', 'diamante', 'escada', 'foca', 'garrafa', 'hipopotamo', 'internet', 'jornal',
  'karate', 'limonada', 'mochila', 'neve', 'orelha', 'pato', 'quimono', 'relampago', 'salada', 'tapete',
  'urso', 'vela', 'watt', 'xadrezista', 'yeti', 'zangado', 'alface', 'barril', 'cavalo', 'deserto',
  'escudo', 'flauta', 'golfinho', 'hamburguer', 'impressora', 'jiboia', 'karaoke', 'lobo', 'montanha', 'notebook',
  'olho', 'panela', 'queimador', 'rato', 'sandalia', 'telefone', 'ventilador', 'whatsapp', 'xaxim',
  'yakisoba', 'zumbi', 'banana', 'chuva', 'drone', 'escorrega', 'foguete', 'gelo', 'hotel',
  'jeito', 'kilograma', 'livro', 'minhoca', 'nariz', 'porta', 'presunto', 'rede',
  'sabao', 'trem', 'vassoura', 'webcam', 'youtuber', 'ziguezague', 'anjo', 'bule',
  'colar', 'desenho', 'espelho', 'farol', 'gato', 'horta', 'inseto', 'joaninha', 'ketchup', 'leao',
  'manga', 'noite', 'objeto', 'pena', 'quartzo', 'regua', 'serpente', 'tinta', 'universo', 'vulcao'
];

const generateDicewarePassword = () => {
  const words = [];
  for (let i = 0; i < 2; i++) {
    const randomIndex = Math.floor(Math.random() * dicewareWords.length);
    words.push(dicewareWords[randomIndex]);
  }
  return words.join('-') + Math.floor(Math.random() * 100);
};

const SignupSiteNew = () => {
  const { signup } = useAuth();
  const navigate = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nameErr, setNameErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [passwordErr, setPasswordErr] = useState('');
  const [suggestedPassword, setSuggestedPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateName = () => {
    if (name.trim() === '') {
      setNameErr("Digite o seu nome");
      return false;
    }
    setNameErr("");
    return true;
  };

  const validateEmail = () => {
    if (email.trim() === '') {
      setEmailErr("Digite o seu email");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailErr("Digite um email válido");
      return false;
    }
    setEmailErr("");
    return true;
  };

  const validatePassword = () => {
    if (password.trim() === '') {
      setPasswordErr("Digite a senha desejada");
      return false;
    }
    if (password.length < 8) {
      setPasswordErr("Mínimo de 8 caracteres");
      return false;
    }
    setPasswordErr("");
    return true;
  };

  const handleNextStep = () => {
    if (currentStep === 1 && validateName()) {
      setCurrentStep(2);
    } else if (currentStep === 2 && validateEmail()) {
      setCurrentStep(3);
      // Generate suggested password when entering step 3
      if (!suggestedPassword) {
        setSuggestedPassword(generateDicewarePassword());
      }
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const useSuggestedPassword = () => {
    setPassword(suggestedPassword);
    setPasswordErr("");
  };

  const generateNewPassword = () => {
    const newPassword = generateDicewarePassword();
    setSuggestedPassword(newPassword);
  };

  const handleSubmit = async () => {
    if (!validatePassword()) return;

    setIsSubmitting(true);
    try {
      const data = await signup(email, password, name);
      
      // Analytics tracking
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'siteSignUp',
          buttonName: 'signUpButton',
        });
      }
      
      const user_id = data.userSub;
      notify("SITE SIGNUP", `${name} (${email}) se cadastrou no site!`);
      navigate(`/verify?email=${email}`);
    } catch (err) {
      console.log(err);
      alert("Erro ao criar conta: " + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStepTitle = () => {
    switch (currentStep) {
      case 1: return "Vamos começar a dominar os circuitos? Diga o seu nome";
      case 2: return "Agora, qual é o seu email?";
      case 3: return "Por último, escolha sua senha";
      default: return "Criar conta";
    }
  };

  const getStepDescription = () => {
    switch (currentStep) {
      case 1: return "O nome será usado para identificar você na área interna.";
      case 2: return "O email será o seu nome de usuário para fazer login no site.";
      case 3: return "Sugerimos uma senha segura, mas você pode criar a sua própria.";
      default: return "";
    }
  };

  return (
    <section id="form" className="section-signup">
      <div className="auth-container-signup">
        <div className="progress-bar">
          <div className="progress-steps">
            {[1, 2, 3].map((step) => (
              <div
                key={step}
                className={`progress-step ${currentStep >= step ? 'active' : ''}`}
              >
                {step}
              </div>
            ))}
          </div>
          <div className="progress-line">
            <div 
              className="progress-fill"
              style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
            ></div>
          </div>
        </div>

        <h2>{getStepTitle()}</h2>
        <p className="signup-benefits">{getStepDescription()}</p>

        <div className="form">
          {currentStep === 1 && (
            <div className="step-content">
              <div className="formfield">
                <TextField
                  value={name}
                  fullWidth
                  onChange={(e) => setName(e.target.value)}
                  label="Digite seu nome completo"
                  helperText={nameErr}
                  autoFocus
                />
              </div>
              <div className="formfield">
                <Button 
                  className="continue-button"
                  variant="contained" 
                  onClick={handleNextStep}
                  disabled={!name.trim()}
                >
                  Continuar
                </Button>
              </div>
            </div>
          )}

          {currentStep === 2 && (
            <div className="step-content">
              <div className="formfield">
                <TextField
                  value={email}
                  fullWidth
                  onChange={(e) => setEmail(e.target.value)}
                  label="Digite seu melhor email"
                  type="email"
                  helperText={emailErr}
                  autoFocus
                />
              </div>
              <div className="formfield button-group">
                <Button 
                  className="back-button"
                  variant="contained" 
                  onClick={handlePrevStep}
                >
                  Voltar
                </Button>
                <Button 
                  className="continue-button"
                  variant="contained" 
                  onClick={handleNextStep}
                  disabled={!email.trim()}
                >
                  Continuar
                </Button>
              </div>
            </div>
          )}

          {currentStep === 3 && (
            <div className="step-content">
              <div className="password-suggestion">
                <p><strong>Sugerimos esta senha segura:</strong></p>
                <div className="suggested-password">
                  <code>{suggestedPassword}</code>
                  <button 
                    type="button" 
                    onClick={generateNewPassword}
                    className="regenerate-btn"
                  >
                    🎲 Nova sugestão
                  </button>
                </div>
                <Button 
                  className="suggest-password-button"
                  variant="contained"
                  onClick={useSuggestedPassword}
                  fullWidth
                >
                  Usar esta senha
                </Button>
                <p className="or-divider">ou crie sua própria senha:</p>
              </div>

              <div className="formfield">
                <TextField
                  value={password}
                  fullWidth
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  label="Digite sua senha personalizada"
                  helperText={passwordErr}
                />
              </div>
              
              <p className="avisosobresenha">A senha deve ter no mínimo 8 caracteres.</p>
              
              <div className="formfield button-group">
                <Button 
                  className="back-button"
                  variant="contained" 
                  onClick={handlePrevStep}
                >
                  Voltar
                </Button>
                <Button 
                  className="create-account-button"
                  variant="contained" 
                  disabled={!password.trim() || isSubmitting}
                  onClick={handleSubmit}
                >
                  {isSubmitting ? 'Criando conta...' : 'Criar conta'}
                </Button>
              </div>
            </div>
          )}
        </div>
        <h3>
          Já tem conta? <br />
          <a href="logon">Faça o seu login</a>
        </h3>
        <p className="politicadeprivacidade">
          Seus dados estão seguros. <br />
          <a href="../politicadeprivacidade">Política de privacidade</a>
        </p>
      </div>
    </section>
  );
};

export {Signup, SignupSite, SignupSiteNew};